if (!customElements.get('explore-edition-tabs')) {
  customElements.define(
    'explore-edition-tabs',
    class ExploreEditionTabs extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-explore-nav]');
        if (!this.nav) return;

        this.tabs = Array.from(this.querySelectorAll('[data-explore-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-explore-panel]'));
        this.mql = window.matchMedia('(min-width: 990px)');

        this.tabs.forEach((tab, index) => {
          const panel = this.panels[index];
          const tabId = `ExploreTab-${this.id}-${index}`;
          tab.id = tabId;
          panel.setAttribute('aria-labelledby', tabId);
          tab.addEventListener('click', () => this.activate(index, true));
        });

        this.nav.addEventListener('keydown', (event) => this.onKeydown(event));

        const initialIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.activate(initialIndex === -1 ? 0 : initialIndex, false);

        this.applyMode();
        this.mql.addEventListener('change', () => this.applyMode());
      }

      applyMode() {
        this.isTabMode = this.mql.matches;

        if (this.isTabMode) {
          this.nav.setAttribute('role', 'tablist');
          this.nav.setAttribute('aria-label', this.getAttribute('data-nav-label') || 'Explore the edition');
        } else {
          this.nav.removeAttribute('role');
          this.nav.removeAttribute('aria-label');
        }

        this.tabs.forEach((tab) => {
          tab.setAttribute('role', this.isTabMode ? 'tab' : 'button');
        });

        this.panels.forEach((panel) => {
          if (this.isTabMode) {
            panel.setAttribute('role', 'tabpanel');
          } else {
            panel.removeAttribute('role');
          }
        });

        this.updateTabindex();
      }

      activate(index, moveFocus) {
        this.activeIndex = index;

        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.setAttribute('aria-selected', String(isActive));
          this.panels[i].hidden = !isActive;
        });

        this.updateTabindex();

        if (moveFocus) {
          this.tabs[index].focus();
        }
      }

      updateTabindex() {
        this.tabs.forEach((tab, i) => {
          if (!this.isTabMode) {
            tab.removeAttribute('tabindex');
            return;
          }
          tab.setAttribute('tabindex', i === this.activeIndex ? '0' : '-1');
        });
      }

      onKeydown(event) {
        if (!this.isTabMode) return;
        const key = event.key;
        if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;

        const currentIndex = this.tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        event.preventDefault();

        let nextIndex = currentIndex;
        if (key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (key === 'Home') nextIndex = 0;
        if (key === 'End') nextIndex = this.tabs.length - 1;

        this.activate(nextIndex, true);
      }
    }
  );
}
